import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { combineLatest } from 'rxjs/internal/observable/combineLatest';
import { filter } from 'rxjs/internal/operators/filter';
import { map } from 'rxjs/internal/operators/map';
import { switchMap } from 'rxjs/internal/operators/switchMap';
import { AppService } from './auth/app.service';
import { CoreModule } from './core/core.module';
import { ContentPath } from './core/content-header/content-path';
import { ContentHeaderService } from './core/content-header/content-header.service';
import { AppUpdateService } from './core/app-update.service';

@Component({
  selector: 'app-root',
  imports: [CoreModule],
  templateUrl: './app.html',
  styleUrl: './app.less'
})
export class App implements OnInit {

  appManutencao: boolean = false;
  aplicacaoIniciada: boolean = false;
  appInicializacao: number = 0;

  title: string = 'Dashboard';
  subtitle: string = '';
  showContentHeader: boolean = true;
  contentsPath: ContentPath[] = [];
  contentId: string = '';

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    public app: AppService,
    private contentHeaderService: ContentHeaderService,
    private appUpdateService: AppUpdateService
  ) {
    router.events.pipe(
      filter((event) => event instanceof NavigationEnd || event instanceof NavigationStart),
      map((event) => {
        if (event instanceof NavigationStart) {
          this.showContentHeader = false;
          this.contentHeaderService.updateState({
            showContentHeader: false,
            loading: true,
          });
        }

        return event;
      }),
      filter((event) => event instanceof NavigationEnd),
      switchMap(() => {
        let currentRoute: ActivatedRoute = this.activatedRoute;

        while (currentRoute.firstChild) {
          currentRoute = currentRoute.firstChild;
        }

        return combineLatest([currentRoute.data, currentRoute.paramMap]);
      })
    ).subscribe((result) => {
      const routeData = result[0] as any;
      const resolvedHeader = routeData['courseHeader'] as { title?: string; subtitle?: string } | undefined;

      this.contentId = result[1].get('id') ?? '';
      this.title = resolvedHeader?.title ?? routeData['title'] ?? this.title;
      this.subtitle = resolvedHeader?.subtitle ?? routeData['subtitle'] ?? '';
      this.contentsPath = routeData['contentsPath'] ?? [];
      this.showContentHeader = routeData['showContentHeader'] !== false;
      this.contentHeaderService.updateState({
        title: this.title,
        subtitle: this.subtitle,
        showContentHeader: this.showContentHeader,
        contentsPath: this.contentsPath,
        contentId: this.contentId,
        loading: false,
      });

      this.titleService.setTitle(this.title);
      window.scrollTo({ top: 0 });
    });
  }

  ngOnInit(): void {
    // Inicializa o serviço de verificação de atualizações.
    this.appUpdateService.checkForUpdates();
  }
}
